// Design tokens - Single source of truth for all design values
export const designTokens = {
  colors: {
    // Brand colors
    brand: {
      primary: {
        50: '#E7B3DA',
        100: '#E1A2D0',
        200: '#D47FBC',
        300: '#C85CA8',
        400: '#BA3994',
        500: '#AD1781', // Main brand color
        600: '#A3167A',
        700: '#991474',
        800: '#8E126D',
        900: '#841168',
        950: '#7F1166',
      },
      secondary: {
        50: '#F4B3DD',
        100: '#ECA8D4',
        200: '#DB8EC2',
        300: '#CB75B1',
        400: '#BC5EA0',
        500: '#AD45A1', // Main secondary color
        600: '#A34198',
        700: '#993D8E',
        800: '#8E3985',
        900: '#84357B',
        950: '#7F3376',
      },
    },

    // Semantic colors
    semantic: {
      success: {
        50: '#75E0A7',
        100: '#6AD69E',
        200: '#55C88E',
        300: '#40BA7F',
        400: '#2BAB6F',
        500: '#12B76A',
        600: '#0FA45E',
        700: '#0C9153',
        800: '#097E47',
        900: '#066B3C',
        950: '#039855',
      },
      warning: {
        50: '#FFB000',
        100: '#FAC601',
        200: '#F5B802',
        300: '#F0AA04',
        400: '#E89C06',
        500: '#F79009',
        600: '#E98507',
        700: '#DA7A06',
        800: '#CC6F04',
        900: '#BD6403',
        950: '#DC6803',
      },
      error: {
        50: '#FDA29B',
        100: '#FA8E84',
        200: '#F77A6D',
        300: '#F56656',
        400: '#F2523F',
        500: '#F04438',
        600: '#E93B2D',
        700: '#E23223',
        800: '#DB2918',
        900: '#D4200E',
        950: '#D92D20',
      },
      info: {
        50: '#EFF6FF',
        100: '#DBEAFE',
        200: '#BFDBFE',
        300: '#93C5FD',
        400: '#60A5FA',
        500: '#3B82F6',
        600: '#2563EB',
        700: '#1D4ED8',
        800: '#1E40AF',
        900: '#1E3A8A',
        950: '#172554',
      },
    },

    // Neutral/grayscale
    neutral: {
      0: '#FFFFFF',
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#E4E4E7',
      300: '#D1D1D6',
      400: '#A0A0AB',
      500: '#71717A',
      600: '#51525C',
      700: '#3F3F46',
      800: '#27272A',
      900: '#18181B',
      950: '#09090B',
    },
  },

  // Typography tokens
  typography: {
    fontFamily: {
      primary: ['Rubik', 'system-ui', 'sans-serif'],
      mono: ['ui-monospace', 'SFMono-Regular', 'monospace'],
    },
  },

  // Surface colors for backgrounds
  surface: {
    base: '#FFFFFF',
    secondary: '#F9FAFB',
    tertiary: '#F3F4F6',
    accent: '#FCF5F2', // Your cream background
    overlay: 'rgba(0, 0, 0, 0.5)',
  },
};

// Type helpers for design tokens
export type ColorScale = keyof typeof designTokens.colors.brand.primary;
export type SemanticColor = keyof typeof designTokens.colors.semantic;
export type BrandColor = keyof typeof designTokens.colors.brand;
